import script from "./ScanReviewRequestsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ScanReviewRequestsTable.vue?vue&type=script&setup=true&lang=js"

import "./ScanReviewRequestsTable.vue?vue&type=style&index=0&id=2baf9092&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2baf9092"]])

export default __exports__